import { create } from 'zustand';
import { SiteListFilterObject, siteListFilterInitialValues } from './siteListFilterStore';

interface CompetitionFilterStore {
	competitionFilter: SiteListFilterObject;
	upcomingFilter: SiteListFilterObject;
	updateFilter: (name: string, filterObject: SiteListFilterObject) => void;
	resetFilter: (name: string) => void;
}

const initialState = {
	competitionFilter: { ...siteListFilterInitialValues, solvent_used_c: 'Competition' },
	upcomingFilter: { ...siteListFilterInitialValues, site_current_status_c: 'Upcoming' },
};

export const useCompetitionFilterStore = create<CompetitionFilterStore>((set) => ({
	...initialState,
	updateFilter: (name: string, filterObject: SiteListFilterObject): void => {
		set(() => ({ [name]: filterObject }));
	},
	resetFilter: (name: string): void => {
		if (name === 'competitionFilter') {
			set(() => ({ competitionFilter: { ...siteListFilterInitialValues, solvent_used_c: 'Competition' } }));
		} else if (name === 'upcomingFilter') {
			set(() => ({ upcomingFilter: { ...siteListFilterInitialValues, site_current_status_c: 'Upcoming' } }));
		}
	},
}));
